import React from 'react';
import { PortableTextBlock } from '@portabletext/types';
import { PortableText } from '@portabletext/react';
import { useQuery } from 'react-query';
import { fetchPois } from 'data/fetchers';
import PoiCard from 'components/cards/poi/PoiCard';
import slugify from 'slugify';
import { SanityDocument } from '@sanity/types/src/documents/types';
import PoiBlock from 'content/PoiBlock';

export interface IPoiCollectionBlock extends SanityDocument {
    pois: PoiBlock[];
    title: string;
    description: PortableTextBlock;
    _type: 'poiCollection';
}

const PoiCollectionBlock = ({ value: block }: { value: IPoiCollectionBlock }) => {
    const poiIds = block?.pois?.map((poi) => poi.id);
    const filters = poiIds.map((id) => ({ key: 'id', value: id }));
    const includes = ['areas', 'type', 'thumbs', 'attributes.attribute'];
    const { data: pois } = useQuery(['poi_by_ids', ...poiIds], () => fetchPois({ filters, includes }));

    return (
        <div className="py-8">
            <div className="scroll-anchor" id={slugify(block.title, { lower: true })} />
            <h2 className="font-sans font-bold">{block.title}</h2>
            <PortableText value={block.description} />
            <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                {pois?.data.map((poi) => (
                    <PoiCard
                        key={poi.id}
                        prefetch={false}
                        images={poi.thumbs}
                        title={poi.name}
                        link={`/ideja/${poi.slug}`}
                        location={`${poi.areas.find((area) => area.type.key === 'municipality')?.name}, ${
                            poi.areas.find((area) => area.type.key === 'region')?.name
                        }`}
                        poiType={poi.type}
                        attributes={poi.attributes}
                    />
                ))}
            </div>
        </div>
    );
};

export default PoiCollectionBlock;
